/**
 * Utilities for interacting with Facebook and its JS SDK.
 */
import {Errors, KAError} from "@khan/logging";
import {InitialRequestUrl, RequestInfo} from "@khan/shared-core";

// Implicit global: Facebook SDK
declare let FB: any;

// sync-start:fb-app-id 920843996 ./apps/khanacademy/src/data-access/page-metadata.ts
export const FB_APP_ID = "160249463991765";
// sync-end:fb-app-id

/**
 * Loads the Facebook JavaScript SDK.
 */
export const loadFacebookApi = (): Promise<any> => {
    // @ts-expect-error - TS2339 - Property 'FB' does not exist on type 'Window & typeof globalThis'.
    if (typeof window !== "undefined" && window.FB) {
        // @ts-expect-error - TS2339 - Property 'FB' does not exist on type 'Window & typeof globalThis'.
        return Promise.resolve(window.FB);
    }

    // @ts-expect-error - TS2339 - Property 'fbAsyncInit' does not exist on type 'Window & typeof globalThis'.
    window.fbAsyncInit = function () {
        FB.init({
            version: "v10.0",
            appId: FB_APP_ID,
            status: false, // Fetch status conditionally below.
            cookie: true,
            xfbml: true,
            oauth: true,
            kidDirectedSite: true,
        });
    };

    return new Promise((resolve, reject) => {
        const locale = RequestInfo.kaLocale.replace(/-/g, "_");
        const script = document.createElement("script");
        script.src = `${InitialRequestUrl.protocol}//connect.facebook.net/${locale}/sdk.js?xfbml=1&kidDirectedSite=1`;
        script.onload = () => {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS2339 - Property 'FB' does not exist on type 'Window & typeof globalThis'.
            resolve(window.FB);
        };
        script.onerror = (error: unknown) => {
            reject(error);
        };
        const fbRoot = document.getElementById("fb-root");
        if (fbRoot) {
            fbRoot.appendChild(script);
        }
    });
};

/**
 * Attempts to authenticate the user using FB.login.
 * @see https://developers.facebook.com/docs/reference/javascript/FB.login
 *
 * @returns {Promise<string>} The token generated by Facebook.
 */
export const getFacebookAuthToken = (): Promise<string> => {
    return loadFacebookApi().then((FB) => {
        return new Promise((resolve, reject) => {
            // We have already initialized FB at this point (see init() above).
            FB.login(
                (response: any) => {
                    if (response.authResponse) {
                        resolve(response.authResponse.accessToken);
                    } else {
                        reject(
                            new KAError(
                                "Could not get FB access token",
                                Errors.Internal,
                            ),
                        );
                    }
                },
                {scope: "email"},
            );
        });
    });
};
